import { get } from '../utils/http';
import { buildSpectateUrl } from '../../spa/Utils/Spectate';
import { getIsMobileWrapperFlag } from '../utils/user';

/**
 * The selection recommendations end point
 * @type {String}
 */
export const SELECTION_RECOMMENDATIONS_ENDPOINT = '/recommendations-req/';

/**
 * The recommend selections delay state key
 * @type {Number}
 */
export const RECOMMEND_SELECTIONS_DELAY_STATE_KEY = 'recommend:selections:delay';

/**
 * Returns a promise for selection recommendations based on selection choices.
 * @param {Array} selectionChoices Array of selections to use for recommendations
 * @param {String} recommendationLocation The location in betlip which the request is calling from (BETSLIP or BET_RECEIPT)
 * @return {Promise.<data, Error>} returns a promise that resolves with the data
 * as json or rejects with an error object
 */
export function getSelectionRecommendations (selectionChoices, recommendationLocation) {
    const getOptions = {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    };

    const endpointUrl = buildSpectateUrl(
        `${SELECTION_RECOMMENDATIONS_ENDPOINT}?selection_choices=${selectionChoices}&recommendation_location=${recommendationLocation}&isMobile=${getIsMobileWrapperFlag()}`
    );

    return get(endpointUrl, getOptions)
        .then((response) => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            return response.json();
        })
        .then(({ data }) => data)
        .catch((error) => {
            throw error;
        });
}
